<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col class="page-top d-flex justify-space-between" cols="12">
                <div>
                  <div class="page-title">{{ stage_name }}</div>
                  <div class="breadcrumb">Монитор продления / {{ stage_name }}</div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-col>
          <v-sheet
              rounded="lg"
          >
            <v-card-title
                class="custom__card-title"
            >
              <div class="search_client">
                <v-text-field
                    v-model="search"
                    rounded
                    outlined
                    dense
                    hide-details
                    single-line
                    label="Поиск"
                    style="font-size: 12px;font-weight: normal"
                    background-color="white"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </div>
              <div class="filter_client">
                <v-btn
                    dark
                    class="filter-button"
                    :disabled="isLoading"
                    @click="dialogFiler = !dialogFiler"
                >
                  <img
                      class="mr-1"
                      src="/playground_assets/mediumfilter.svg"
                  >
                  Фильтр
                </v-btn>
              </div>

            </v-card-title>
            <v-card-text
                v-show="dialogFiler"
            >
              <v-container>
                <v-row>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Статус</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.status_deal"
                        :items="statusDealTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Клубы</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.club"
                        :items="list.monitor"
                        item-value="club.id"
                        item-text="club.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Менеджер</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.manager"
                        :items="list.monitor"
                        item-value="manager.id"
                        item-text="manager.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Кем создан</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.user"
                        :items="list.monitor"
                        item-value="user.id"
                        item-text="user.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Источник</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.advertising_source"
                        :items="list.monitor"
                        item-value="advertising_source.id"
                        item-text="advertising_source.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Тег</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.tag"
                        :items="list.monitor"
                        item-value="tag"
                        item-text="tag"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Интерес</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.interests"
                        :items="list.monitor"
                        item-value="interests"
                        item-text="interests"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Задачи</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.scheduled_task"
                        :items="scheduledTaskTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Канал</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.advertising_platform"
                        :items="list.monitor"
                        item-value="advertising_platform.id"
                        item-text="advertising_platform.name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Создана</label>
                    <VueDatePicker
                        @input="collectData"
                        no-title
                        no-header
                        range
                        rangeInputText="%d - %d"
                        format="DD MMMM"
                        color="#629f34"
                        v-model="dealsFilter.date_creation"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__datepicker"
                            ref="activator"
                            type="button"
                        >
                          <div>
                            <span v-if="dealsFilter.date_creation">{{ date }}</span>
                            <span v-else style="color: gray">Выберите период</span>
                          </div>
                          <v-icon
                              medium
                              right
                              class="ml-5"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                        </button>
                      </template>
                    </VueDatePicker>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Запланированная задача</label>
                    <VueDatePicker
                        @input="collectData"
                        no-title
                        no-header
                        range
                        rangeInputText="%d - %d"
                        format="DD MMMM"
                        color="#629f34"
                        v-model="dealsFilter.date_schedule"
                        style="flex: none !important;"
                    >
                      <template #activator="{ date }">
                        <button
                            class="button custom__datepicker"
                            ref="activator"
                            type="button"
                        >
                          <div>
                            <span v-if="dealsFilter.date_schedule">{{ date }}</span>
                            <span v-else style="color: gray">Выберите период</span>
                          </div>
                          <v-icon
                              medium
                              right
                              class="ml-5"
                          >
                            mdi-calendar-blank-outline
                          </v-icon>
                        </button>
                      </template>
                    </VueDatePicker>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="3"
                      md="3"
                  >
                    <label>Справка</label>
                    <v-select
                        @input="collectData"
                        class="rounded-lg custom__select"
                        v-model="dealsFilter.reference"
                        :items="referenceTypes"
                        item-value="value"
                        item-text="name"
                        :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                        placeholder="Значение" append-icon="mdi-chevron-down" outlined
                        dense
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-card-actions class="mt-4">
                    <template v-if="!dialogButton">
                      <button
                          class="button custom__button mt-5"
                          type="button"
                          @click="returnDeals"
                      >
                        Применить
                      </button>
                    </template>
                    <template v-else>
                      <button
                          class="button custom__button mt-5"
                          type="button"
                          @click="filterDeals(dealsFilter)"
                          style="background-color: #A13453 !important;color: #fff !important;"
                      >
                        Применить
                      </button>
                      <button
                          class="button custom__button mt-5 ml-3"
                          type="button"
                          style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                          @click="clearData"
                      >
                        Сбросить фильтр
                      </button>
                    </template>
                  </v-card-actions>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- <v-data-table
                v-if="list && list.monitor"
                :headers="headersDeals"
                :items="list.monitor"
                no-data-text="Результатов не найдено"
                :hide-default-footer="true"
                :page="page"
                :search="search"
                class="elevation-1"
                :server-items-length="list.listLength"
                :items-per-page="toggle_exclusive"
            >
              <template v-slot:item.client.name="{ item }">
                <router-link
                    :to="{ name: 'CardClientNew', params: {client_id: item.client.id}}"
                    class="d-flex"
                    style="align-items: center; text-decoration: none; color: #000"
                >
                  {{ item.client.name }}
                </router-link>
              </template>
              <template v-slot:item.date_creation="{ item }">
                {{ formatDate(item.date_creation) }}
              </template>
              <template v-slot:item.advertising_params="{ item }">
                {{ item.advertising_source.name }}{{ item.advertising_platform.name ? ', ' + item.advertising_platform.name : ''}}
              </template>
            </v-data-table> -->

            <v-data-table
                v-if="list && list.monitor"
                    :headers="headersDeals"
                    :items="list.monitor"
                    no-data-text="Результатов не найдено"
                    :hide-default-footer="true"
                    :page="page"
                    class="elevation-1"
                    :server-items-length="list.monitor.listLength"
                    :items-per-page="toggle_exclusive"
            >
              <template v-slot:item.client.name="{ item }">
                <router-link
                    :to="{ name: 'CardClientNew', params: {client_id: item.client.id}}"
                    class="d-flex"
                    style="align-items: center; text-decoration: none; color: #000"
                >
                  {{ item.client.name }}
                </router-link>
              </template>
         
              <template v-slot:item.date_creation="{ item }">
                {{ formatDate(item.date_creation) }}
              </template>
              <template v-slot:item.advertising_params="{ item }">
                {{ item.advertising_source.name }}{{ item.advertising_platform.name ? ', ' + item.advertising_platform.name : ''}}
              </template>
            </v-data-table>

            <v-card-actions
                      class="d-flex justify-content-between"
                      style="padding: 20px !important;"
                  >
                    <template v-if="list && list.listLength">
                      <div>
                        <span class="desktopRegularLabel"><span>Показано с 1 по {{ toggle_exclusive }} из {{ list.listLength }} результатов</span></span>
                      </div>
                      <div>
                        <v-pagination
                            v-model="page"
                            circle
                            color="#629F33"
                            :length="list.paginationLength"
                            :total-visible="8"
                        ></v-pagination>
                      </div>
                    </template>
                  </v-card-actions>
          </v-sheet>

        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
//import {monitorActionTypes} from "@/store/modules/monitor";
import {renewalActionTypes} from "@/store/modules/renewal";
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";

export default {
  name: 'DealsStageRenewal',
  props: ['specialist_id', 'startdate', 'enddate', 'type_id', 'stage_id', 'stage_name'],
  components: {
    VueDatePicker,
    Header,
    Menu,
  },
  computed: {
    ...mapState({
      isLoading: state => state.renewal.isLoading,
      list: state => state.renewal.list,
      validationErrors: state => state.renewal.validationErrors
    })
  },
  methods: {
    fetchFeed(specialist_id, startdate, enddate, type_id, stage_id, search) {
      let page = this.page
      let limit = this.toggle_exclusive

      let client_search = search ? search : null

      this.$store.dispatch(renewalActionTypes.getDealsStageRenewal, {
        specialist_id,
        startdate,
        enddate,
        type_id,
        stage_id,
        page,
        limit,
        client_search
      })
    },
    collectData(selected) {
      this.selected.push(selected)
      if (this.selected !== [] || this.dealsFilter.date_creation !== null || this.dealsFilter.date_end !== null || this.dealsFilter.date_schedule !== null) {
        this.dialogButton = true;
      }
    },
    clearData() {
      this.selected.length = 0;
      this.dealsFilter.status_deal = null;
      this.dealsFilter.club = null;
      this.dealsFilter.manager = null;
      this.dealsFilter.user = null;
      this.dealsFilter.advertising_source = null;
      this.dealsFilter.tag = null;
      this.dealsFilter.interests = null;
      this.dealsFilter.scheduled_task = null;
      this.dealsFilter.advertising_platform = null;
      this.dealsFilter.date_creation = null;
      this.dealsFilter.date_schedule = null;
      this.dealsFilter.reference = null;
      this.dialogButton = false;
    },
    filterDeals(deals) {
      if (deals.status_deal !== null) {
        this.list.monitor = this.list.monitor.filter((item) => (item.date_creation !== "") === deals.status_deal);
      }
      if (deals.club !== null) {
        this.list.monitor = this.list.monitor.filter((item) => item.club.id === deals.club);
      }
      if (deals.manager !== null) {
        this.list.monitor = this.list.monitor.filter((item) => item.manager.id === deals.manager);
      }
      if (deals.user !== null) {
        this.list.monitor = this.list.monitor.filter((item) => item.user.id === deals.user);
      }
      if (deals.advertising_source !== null) {
        this.list.monitor = this.list.monitor.filter((item) => item.advertising_source.id === deals.advertising_source);
      }
      if (deals.tag !== null) {
        this.list.monitor = this.list.monitor.filter((item) => item.tag === deals.tag);
      }
      if (deals.interests !== null) {
        this.list.monitor = this.list.monitor.filter((item) => item.interests === deals.interests);
      }
      if (deals.scheduled_task !== null) {
        this.list.monitor = this.list.monitor.filter((item) => (item.scheduled_task.length !== 0) === deals.scheduled_task);
      }
      if (deals.advertising_platform !== null) {
        this.list.monitor = this.list.monitor.filter((item) => item.advertising_platform.id === deals.advertising_platform);
      }
      if (deals.date_creation !== null) {
        this.list.monitor = this.list.monitor.filter((item) => new Date(deals.date_creation.start) <= new Date(item.date_creation) && new Date(item.date_creation) <= new Date(deals.date_creation.end));
      }
      if (deals.date_schedule !== null) {
        this.list.monitor = this.list.monitor.filter((item) => new Date(deals.date_schedule.start) <= new Date(item.scheduled_task.date) && new Date(item.scheduled_task.date) <= new Date(deals.date_schedule.end));
      }
      if (deals.reference !== null) {
        this.list.monitor = this.list.monitor.filter((item) => item.reference === deals.reference);
      }
    },
    returnDeals() {
      if (!this.dialogButton) {
        this.fetchFeed(this.specialist_id, this.startdate, this.enddate, this.type_id, this.stage_id);
      }
    },
    formatDate(date) {
      date = new Date(date);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const formattedDay = (day < 10) ? `0${day}` : day;
      const formattedMonth = (month < 10) ? `0${month}` : month;

      return `${formattedDay}.${formattedMonth}.${year}`;
    }
  },
  mounted() {
    this.specialist_id !== undefined ? setItem('deals-specialist_id', this.specialist_id) : this.specialist_id = JSON.parse(getItem('deals-specialist_id'));
    this.type_id !== undefined ? setItem('deals-type_id', this.type_id) : this.type_id = getItem('deals-type_id');
    this.stage_id !== undefined ? setItem('deals-stage_id', this.stage_id) : this.stage_id = getItem('deals-stage_id');
    this.stage_name !== undefined ? setItem('deals-stage_name', this.stage_name) : this.stage_name = getItem('deals-stage_name');
    if (this.startdate === undefined && this.enddate === undefined) {
      this.startdate = new Date();
      this.enddate = new Date();
    }
    this.fetchFeed(this.specialist_id, this.startdate, this.enddate, this.type_id, this.stage_id);
  },
  watch: {
    toggle_exclusive() {
      this.page = 1;
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.startdate, this.enddate, this.type_id, this.stage_id);
      }
    },
    page() {
      if (this.search === '') {
        // let page = this.page;
        // let limit = this.toggle_exclusive;
        this.fetchFeed(this.specialist_id, this.startdate, this.enddate, this.type_id, this.stage_id);
      } else {
        this.fetchFeed(this.specialist_id, this.startdate, this.enddate, this.type_id, this.stage_id, this.search);
      }
    },
    search() {
      if (this.search !== '') {
            this.loading = true
            this.specialist_id !== undefined ? setItem('deals-specialist_id', this.specialist_id) : this.specialist_id = JSON.parse(getItem('deals-specialist_id'));
            this.type_id !== undefined ? setItem('deals-type_id', this.type_id) : this.type_id = getItem('deals-type_id');
            this.stage_id !== undefined ? setItem('deals-stage_id', this.stage_id) : this.stage_id = getItem('deals-stage_id');
            this.stage_name !== undefined ? setItem('deals-stage_name', this.stage_name) : this.stage_name = getItem('deals-stage_name');
            if (this.startdate === undefined && this.enddate === undefined) {
              this.startdate = new Date();
              this.enddate = new Date();
            }
            this.fetchFeed(this.specialist_id, this.startdate, this.enddate, this.type_id, this.stage_id, this.search);
        } else {
            this.loading = true
            this.specialist_id !== undefined ? setItem('deals-specialist_id', this.specialist_id) : this.specialist_id = JSON.parse(getItem('deals-specialist_id'));
            this.type_id !== undefined ? setItem('deals-type_id', this.type_id) : this.type_id = getItem('deals-type_id');
            this.stage_id !== undefined ? setItem('deals-stage_id', this.stage_id) : this.stage_id = getItem('deals-stage_id');
            this.stage_name !== undefined ? setItem('deals-stage_name', this.stage_name) : this.stage_name = getItem('deals-stage_name');
            if (this.startdate === undefined && this.enddate === undefined) {
              this.startdate = new Date();
              this.enddate = new Date();
            }
            this.fetchFeed(this.specialist_id, this.startdate, this.enddate, this.type_id, this.stage_id);
          }
      }
  },
  data() {
    return {
      search: '',
      select: null,
      selected: [],
      dialogFiler: false,
      dialogButton: false,
      page: 1,
      valid: true,
      dealsFilter: {
        status_deal: null,
        club: null,
        manager: null,
        user: null,
        advertising_source: null,
        tag: null,
        interests: null,
        scheduled_task: null,
        advertising_platform: null,
        date_creation: null,
        date_schedule: null,
        reference: null
      },
      statusDealTypes: [
        {name: 'Завершена', value: true},
        {name: 'Не завершена', value: false}
      ],
      scheduledTaskTypes: [
        {name: 'Есть задача', value: true},
        {name: 'Нет задач', value: false}
      ],
      referenceTypes: [
        {name: 'Да', value: true},
        {name: 'Нет', value: false}
      ],
      headersDeals: [
        {text: 'Клиент', align: 'start', value: 'client.name'},
        {text: 'Создана', value: 'date_creation'},
        {text: 'Тег', value: 'tag'},
        {text: 'Интересы', value: 'interests'},
        {text: 'Рекламный источник, канал', value: 'advertising_params'},
        {text: 'Запланированная задача', value: 'scheduled_task.name'},
        {text: 'Менеджер', value: 'manager.name'},
        {text: 'Кем создан', value: 'user.name'},
        {text: 'Последняя задача', value: 'last_task.name'}
      ],
      toggle_exclusive:20
    }
  }
}
</script>
<style scoped lang="scss">
.filter {
  padding: 20px;

  .top-line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .w-352 {
      width: 352px;
    }

    .filter-btn {
      background: #A13453;
      border-radius: 12px;
      text-transform: none;
      color: #FFFFFF;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      box-shadow: none;
      padding: 13px 21px;

      svg {
        margin-right: 5px;
      }
    }

  }

  .hidden-block {
    padding-top: 20px;

  }

  &__field {
    &.colspan-4 {
      grid-column: 1 / 5;
    }

    &.button-block {
      button {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    .label {
      color: #1A1A1A;
      display: block;
      margin-bottom: 8px;
      font-family: 'Circe';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  button {
    border-radius: 12px;
    text-transform: none;
    color: #FFFFFF;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    box-shadow: none;
    padding: 13px 21px;

    &.apply {
      background: #629F33 !important;
      color: #fff !important;
    }

    &.clear {
      background: #F1F1F1 !important;
      color: #1A1A1A !important;
    }

  }
}

.min-w-173 {
  min-width: 173px;
}

.client {
  display: flex;
  align-items: center;

  .ava {
    margin-right: 8px;
  }
}

.vd-activator .custom__datepicker {
  width: 87% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

.custom__button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A !important;
}

.custom__card-title {
  justify-content: space-between;
  flex-wrap: wrap;
}

.search_client {
  min-width: 40%;
  display: flex;
  align-items: center;
}
</style>